<template>
  <div class="pages">
    <img src="/static/other/banner_intro.png" class="tImg" />
    <div class="b_pic_text">
      {{ $t('main.aboutUs') }}
    </div>
    <div
      id="process"
      class="process facab"
      :class="{ isFixed: searchBarFixed }"
    >
      <div class="step" v-for="item in steps" :key="item.id" @click="jump(item.id)">
        <span :class="{ isActived: actived === item.id }">{{ item.name }}</span>
      </div>
    </div>
    <div class="content" id="content">
      <div v-for="item in steps" :key="item.id" :id="item.id">
        <div class="cu_title">
          <div>{{ item.name }}</div>
          <div class="p-c">
            {{ item.intro }}
          </div>
        </div>
        <div v-html="item.content"></div>
      </div>
    </div>
    <el-dialog :visible.sync="isPreview">
      <div class="img-preview">
        <img :src="previewSrc" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getTabs } from "@/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      searchBarFixed: false,
      actived: 0,
      steps: [],
      imgPreview: {},
      previewSrc: "",
      isPreview: false,
      activedImg: {},
      scrollTop: 0
    };
  },
  watch: {
    "$store.state.siteInfo": function() {
      this.init();
    },
    "$store.state.tabs": function() {
      this.init();
    }
  },
  mounted() {
    this.init();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    init() {
      if (localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))) {
        let tabs = this.treeToArray(JSON.parse(localStorage.getItem("navTabs_" + Cookies.get("siteInfo"))));
        let catInfo = tabs.find(item => {
          return item.list_template == "single_intro" && item.pid == 0;
        });
        if (catInfo) {
          this.cat_id = catInfo.id;
          this.getCatInfo();
        }
      }
    },
    getCatInfo () {
      let params = {
        req: {
          pid: this.cat_id,
          site_id: Cookies.get("siteInfo")
        }
      };
      getTabs(params).then(res => {
        if(res.rsp.code === 0) {
          this.steps = res.data.tree.filter(item => {
            return item.status === "1";
          });
          let nowNav = this.steps.find(item => {
            if (item.identification) {
              return this.$route.params.identification == item.identification;
            } else {
              return this.$route.params.identification == item.id;
            }
          });
          if(this.steps.length && nowNav && nowNav.pid != '0') {
            this.$nextTick(() => {
              setTimeout(() => {
                this.jump(nowNav.id);
              }, 500);
              this.imgListener();
            });
          } else {
            this.$nextTick(() => {
              this.imgListener();
            });
          }
        }
      });
    },
    imgListener() {
      let parent = document.getElementById("content");
      let imgs = parent.querySelectorAll("img");
      for (let i = 0; i < imgs.length; i++) {
        imgs[i].addEventListener("click", this.handlePreview);
      }
    },
    treeToArray(data) {
      let res = [];
      function auxiliary(arr) {
        arr.forEach(item => {
          let obj = {
            id: item.id,
            pid: item.pid,
            model_id: item.model_id,
            is_menu: item.is_menu,
            is_post: item.is_post,
            name: item.name,
            image: item.image,
            identification: item.identification,
            list_template: item.list_template,
            article_template: item.article_template,
            child:null
          };
          // 如果是产品则添加 list_template 和 article_template
          if (item.model_id == 23 && item.pid == 0) {
            obj.list_template = 'category_product';
            obj.article_template = 'detail_product';
          }
          if (item.model_id == 23 && item.pid != 0) {
            obj.list_template = 'category_product_more';
            obj.article_template = 'detail_product';
          }

          res.push(obj);
          if (item.child && item.child.length) {
            auxiliary(item.child);
          }
        });
      }
      auxiliary(data);
      return res;
    },
    handlePreview(e) {
      this.isPreview = true;
      // this.activedImg = e.target;
      this.$nextTick(() => {
        this.previewSrc = e.target.currentSrc;
      });
    },
    jump(id) {
      let scrollItem = document.getElementById(id);
      // 锚点对应的模块与最近的一个具有定位的祖宗元素顶部的距离
      this.offsetTop = scrollItem.offsetTop;
      this.actived = id;
      window.scrollTo({
        top: scrollItem.offsetTop - 60,
        behavior: "smooth"
      });
    },
    handleScroll() {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.scrollTop >= document.getElementById("content").offsetTop-60) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
      let heightArr = [];
      this.steps.forEach(item => {
        heightArr.push(document.getElementById(item.id).offsetTop);
      });
      heightArr.forEach((item, index) => {
        if (item - this.scrollTop > 0 && item - this.scrollTop <= 60) {
          this.actived = this.steps[index].id;
        }
      });
    }
  }
};
</script>

<style scoped lang="less">
.pages {
  min-height: 100%;
  background-color: #fff;

  .tImg {
    width: 100%;
  }
  .b_pic_text {
    position: relative;
    bottom: 9rem;
    margin: 0 auto -4.8rem;
    font-family: YouSheBiaoTiHei,serif;
    font-size: 3.5rem;
    font-weight: 400;
    text-align: center;
    font-style: italic;
    color: white;
    background-color: rgba(0,0,0,.5);
    border-radius: 0.5rem;
  }

  .isFixed {
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100%;
  }

  .process {
    height: 60px;
    line-height: 60px;
    background-color: #f2f2f2;

    .step {
      font-size: 1.1428rem;
      color: #1a1a1a;
      cursor: pointer;
    }

    .isActived {
      border-bottom: 4px solid #635796;
      padding-bottom: 0.75rem;
    }
  }

  .content {
    .mt60 {
      margin-top:60px;
    }

    .cu_title {
      font-size: 1.875rem;
      padding-top:60px;
      font-family: YouSheBiaoTiHei,serif;
      font-weight: 400;
      color: #333;
      text-align: center;
    }

    .cont {
      margin-top: 2.5rem;
    }

    .i-box {
      height: 23.75rem;
      background-color: #fafafa;
      padding: 5rem;
      display: flex;

      .left {
        font-size: 1.875rem;
        font-family: YouSheBiaoTiHei,serif;
        font-weight: 400;
        color: #333333;
        border-right: 1px solid #ccc;
      }
    }

    .p-c {
      color: #666666;
      line-height: 35px;
      margin-top: 2.5rem;
    }
  }
  @media screen and (max-width: 1400px) {
    .process {
      padding: 0 2%;
    }
    .content {
      padding: 0 2% 3.25rem;
    }
  }
  @media screen and (min-width: 1400px) {
    .process {
      padding: 0 10%;
    }
    .content {
      padding: 0 10% 3.25rem;
    }
  }
  @media screen and (min-width: 1700px) {
    .process {
      padding: 0 15%;
    }
    .content {
      padding: 0 15% 3.25rem;
    }
  }

  .img-preview {
    width: 500px;
    height: auto;
    min-height: 200px;

    img {
      width: 100%;
    }
  }

  ::v-deep .content img {
    cursor: pointer;
  }
  ::v-deep .el-dialog {
    width: 540px;
    margin-top: 10vh !important;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__headerbtn {
    top:6px;
    right:6px;
  }
  ::v-deep .el-dialog__body {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding: 30px 20px 10px 20px;
  }
}
</style>
